"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getParts = void 0;
const construct_1 = require("./helpers/construct");
/**
 * @description Splits a valid SVG path into it's parts.
 * @param {string} path A valid SVG path
 * @see [Documentation](https://remotion.dev/docs/paths/get-parts)
 * @deprecated In favor of getSubpaths()
 */
const getParts = (path) => {
    const parts = [];
    const constructed = (0, construct_1.construct)(path);
    let i = 0;
    for (const fn of constructed.functions) {
        if (!fn) {
            i++;
            continue;
        }
        const properties = {
            start: fn.getPointAtLength(0),
            end: fn.getPointAtLength(constructed.partial_lengths[i] - constructed.partial_lengths[i - 1]),
            length: constructed.partial_lengths[i] - constructed.partial_lengths[i - 1],
            getPointAtLength: fn.getPointAtLength,
            getTangentAtLength: fn.getTangentAtLength,
        };
        i++;
        parts.push(properties);
    }
    return parts;
};
exports.getParts = getParts;
